import React from 'react';
import {
  TableCell, TableFooter, TableHead, TableRow,
} from '@material-ui/core';
import {
  getTotalColumns, getTotalSumColumns, getValueColumns,
} from '../../../services/p2pSvc';
import { getTotalData } from '../../../services/StratProjIndexSvc';
import { getErrorsInTotal } from '../../../dto/p2p';

const getColumnRenderFunction = (field) => (props) =>
  (props[field] && props[field].value ? props[field].value : 0);

// return props.tableData.childRows.reduce((acc, c) => acc + (c[field] && c[field].value || 0), 0)
//   || 0

export function prefilterTableData(data, years) {
  const fieldsForSelectedYears = getValueColumns(years);

  return data.filter((row) => !fieldsForSelectedYears.every((field) => !row[field] || !row[field].value));
}

const getErrorCheckCellStyle = (cellField, planField,basicStyle={textAlign: 'center'}) => (cellData, rowData) => {
  return getErrorCheckCellDataStyle(cellData,rowData,cellField,basicStyle)
};
const getErrorCheckCellTotalStyle = (totalData,cellField) => {
    return getErrorCheckCellDataStyle(null,totalData,cellField,footerCellStyleNoBorder)
}
const getErrorCheckCellDataStyle = (cellData,rowData,cellField,basicStyle) => {
    let errorStyles = {};
    if (rowData[`${cellField}Error`]) {
        errorStyles = { fontWeight: 'bold', color: '#EE6C68' };
    }

    return {
        ...basicStyle,
        ...errorStyles,
    };
};


export function getYearRelatedColumns(years, funding) {
  const getColumn = (title, field, cellStyle, boldHeader) => ({
    title,
    field,
    render: getColumnRenderFunction(field),
    filtering: false,
    sorting: false,
    width: '10%',
    minWidth: 132,
    filterCellStyle: { minWidth: '70px', width: '12%' },
    headerStyle: { textAlign: 'center', fontWeight: boldHeader && 'bold' },
    cellStyle: cellStyle || { textAlign: 'center' },
  });



  const withBasePart = funding.includes('base');
  const withSpecialPart = funding.includes('special');

  return years
    .sort()
    .reduce(
      (acc, year) => [
        ...acc,
        withBasePart && getColumn(`План по Программе развития ${year}`, `plan${year}B`),
        withSpecialPart && getColumn(`План по Программе развития ${year}`, `plan${year}S`, undefined, true),
        withBasePart && getColumn(`План на ЭГ ${year}`, `planApproved${year}B`, getErrorCheckCellStyle(`planApproved${year}B`, `plan${year}B`)),
        withSpecialPart && getColumn(`План на ЭГ ${year}`, `planApproved${year}S`, getErrorCheckCellStyle(`planApproved${year}S`, `plan${year}S`), true),
        withBasePart && getColumn(`Факт на ЭГ ${year}`, `fact${year}B`, getErrorCheckCellStyle(`fact${year}B`, `plan${year}B`)),
        withSpecialPart && getColumn(`Факт на ЭГ ${year}`, `fact${year}S`, getErrorCheckCellStyle(`fact${year}S`, `plan${year}S`), true),
      ],
      [],
    )
    .filter((col) => col);
}

const getUnitedTotalColNames = (years) => years
  .sort()
  .reduce((acc, year) => [
    ...acc,
    `plan${year}Total`,
    `planApproved${year}Total`,
    `fact${year}Total`,
  ], []);

const footerCellStyle = { color: 'inherit', fontWeight: 'bold' };
const footerCellStyleNoBorder = { color: 'inherit', fontWeight: 'bold', borderTop: '1px solid black' };

export function getHeader(years, funding) {
  const common = { borderBottom: '1px solid black', textAlign: 'center' };
  const bold = { ...common, fontWeight: 'bold' };

  const withBasePart = funding.includes('base');
  const withSpecialPart = funding.includes('special');
  return (
    <TableRow style={{ backgroundColor: '#FFF' }}>
      <TableCell style={common} />
      {years.map(() => (
        <>
          {withBasePart && <TableCell style={common}>Базовая</TableCell>}
          {withSpecialPart && <TableCell style={bold}>Специальная</TableCell>}
          {withBasePart && <TableCell style={common}>Базовая</TableCell>}
          {withSpecialPart && <TableCell style={bold}>Специальная</TableCell>}
          {withBasePart && <TableCell style={common}>Базовая</TableCell>}
          {withSpecialPart && <TableCell style={bold}>Специальная</TableCell>}
        </>
      ))}
    </TableRow>
  );
}

export function getFooter(props, years, funding) {

  const totalColumns = getTotalColumns(years, funding);
  const totalSumColumns = getTotalSumColumns(years);
  const totalData = getTotalData(props.renderData, years, funding);
  const totalErrors = getErrorsInTotal(totalData,years)
  const totalSumColSpan = funding.length;

  return (
    <TableFooter style={{ position: 'sticky', bottom: '0' }}>
      <TableRow style={{ backgroundColor: '#FFF' }}>
        <TableCell align="left" style={footerCellStyleNoBorder}>
          Итого
        </TableCell>
        {totalColumns.map((key) => (
          <TableCell key={key} align="center" style={getErrorCheckCellTotalStyle(totalErrors,key)}>{totalData[key].value}</TableCell>
        ))}
      </TableRow>
      <TableRow style={{ backgroundColor: '#e8f7e4' }}>
        <TableCell align="left" style={footerCellStyle}>
          Суммарно
        </TableCell>
        {/* <TableCell align="center" style={footerCellStyle}> {totalData.allTotal} </TableCell> */}
        {totalSumColumns.map((key) => (
          <TableCell key={key} align="center" colSpan={totalSumColSpan} style={footerCellStyle}>{totalData[key].value}</TableCell>
        ))}
      </TableRow>
    </TableFooter>
  );
}
